// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 594 ? "about" : chunkId) + "-" + {"134":"ab409de60b3a9539574b","594":"924db088d441ca04ecd7"}[chunkId] + ".js";
};